import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../views/Main.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		redirect: "/br",
	},
	{
		path: "/:locale",
		component: Main,
		children: [
			{
				path: "",
				name: "Página inicial",
				component: () => import("../views/Home.vue"),
			},
			{
				path: "cadastrar",
				name: "Cadastro",
				component: () => import("../views/Signup.vue"),
				alias: ["signup", "acceder"],
			},
			{
				path: "editar",
				name: "Editar cadastro",
				component: () => import("../views/EditInfo.vue"),
				alias: "edit",
			},
			{
				path: "publicacao/:id",
				name: "Publicação",
				component: () => import("../views/Publication.vue"),
				alias: ["publication/:id", "publicacion/:id"],
			},
			{
				path: "contratacao",
				name: "Modelo de contratação",
				component: () => import("../views/HiringModel.vue"),
				alias: ["hiringModel", "SCP"],
			},
			{
				path: "*",
				component: () => import("../views/PageNotFound.vue"),
			},
		],
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
});

export default router;
